import { defineStore } from 'pinia'
import type { ISearchPageLink, IRIPStatus, IGlobalSettings, IRIPTexts } from '@/stores/types'
import type { IGlobalAlert, ICompactLinkData, ICompactImage } from '@/components/main-header/types'

export const useGlobalSettingsStore = defineStore('globalSettings', () => {
  const createProfileLink = ref<ICompactLinkData | null>(null)
  const registerProfileLink = ref<ICompactLinkData | null>(null)
  const anyDestinationLink = ref<ICompactLinkData | null>(null)
  const loginLink = ref<ICompactLinkData | null>(null)
  const globalAlert = ref<IGlobalAlert | null>(null)
  const searchPageLink = ref<ISearchPageLink | null>(null)
  const headerFlightStatusLink = ref<ICompactLinkData | null>(null)
  const ogImage = ref<ICompactImage | null>(null)
  const hideFsfPrices = ref<boolean>(false)
  const useOldFsf = ref<boolean>(false)
  const aqfBackLink = ref<ICompactLinkData | null>(null)
  const groupBookingLink = ref<ICompactLinkData | null>(null)
  const hasDataLoaded = ref(false)
  const openBookingTab = ref<boolean>(false)
  const ripStatus = ref<IRIPStatus | null>(null)
  const ripTexts = ref<IRIPTexts | null>(null)

  const init = async () => {
    const { locale } = useI18n()
    const data = await $fetch<IGlobalSettings>('/api/storyblok/global-settings', {
      query: {
        language: locale.value
      }
    })

    if (!data) {
      console.error('\x1b[33m%s\x1b[0m', '[Error]: Something went wrong. Please try again.')
      return
    }

    searchPageLink.value = data?.searchPageLink ? data.searchPageLink : null

    loginLink.value = data?.loginLink ? data.loginLink : null
    ogImage.value = data?.ogImage ? data.ogImage : null
    hideFsfPrices.value = data?.hideFsfPrices ?? false
    useOldFsf.value = data?.useOldFsf ?? false

    headerFlightStatusLink.value = data?.headerFlightStatusLink ? data.headerFlightStatusLink : null
    aqfBackLink.value = data?.aqfBackLink ? data.aqfBackLink : null
    groupBookingLink.value = data?.groupBookingLink ? data.groupBookingLink : null
    anyDestinationLink.value = data?.anyDestinationLink ? data.anyDestinationLink : null

    hideFsfPrices.value = data?.hideFsfPrices ?? false
    useOldFsf.value = data?.useOldFsf ?? false
    openBookingTab.value = data?.openBookingTab ?? false

    ripTexts.value = data?.ripTexts ?? null
    ripStatus.value = {
      flt: data?.rip?.includes('FLT') ?? false,
      mmb: data?.rip?.includes('MMB') ?? false,
      cki: data?.rip?.includes('CKI') ?? false
    }

    globalAlert.value = data?.globalAlert ?? null

    hasDataLoaded.value = true
  }

  return {
    init,
    createProfileLink,
    registerProfileLink,
    globalAlert,
    loginLink,
    searchPageLink,
    ogImage,
    headerFlightStatusLink,
    aqfBackLink,
    ripStatus,
    ripTexts,
    groupBookingLink,
    useOldFsf,
    hideFsfPrices,
    openBookingTab,
    anyDestinationLink
  }
})
